import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import styled from 'styled-components';
import moment from 'moment';
import Moment from 'react-moment';
import _ from 'lodash';
import {AssignmentStatuses, dateFormats, TaskStatusIds, TaskTypeEnum} from '../../../util/uiconstants';
import {currentResource} from '../../../util/utils';
import Utility from '../../../util/utilityfunctions';
import EllipsesControl from '../EllipsesControl/EllipsesControl';
import {getTaskById} from '../../../actions/Ares/TaskList/tasklistactions';
import {updateTaskAssignmentStatus, getAssignmentsByTaskId} from '../../../actions/Ares/TaskList/tasklistactions';
import {useUserPreferences} from '../../../util/customHooks';

function AssignmentsItem(props) {
	const dispatch = useDispatch();
	const userPreferences = useUserPreferences();
	const [isLoading, setIsLoading] = useState(false);

	// Same logic as in Hercules Task List
	const getAssignmentLabel = () => {
		// Find status label
		const assignmentStatusLabel = currentResource.reviewerAssignments.AssignmentStatus.find(
			(at) => at.id === props.assignmentStatusId
		);
		return assignmentStatusLabel;
	};

	const getAssignmentsTitletip = () => {
		const assignmentStatusLabel = getAssignmentLabel();
		return assignmentStatusLabel?.displayName || '';
	};

	const isAssignmentComplete = () => {
		let circleProportionStyle;
		const assignmentStatusLabel = getAssignmentLabel();

		switch (assignmentStatusLabel?.id) {
			case AssignmentStatuses.Open:
				circleProportionStyle = 'empty';
				break;
			case AssignmentStatuses.InProcess:
				circleProportionStyle = 'half';
				break;
			case AssignmentStatuses.Complete:
				circleProportionStyle = 'full';
				break;
			default:
				circleProportionStyle = 'empty';
				break;
		}

		return circleProportionStyle;
	};

	const getAssignedToUserName = () => {
		return props.firstName + ' ' + props.lastName;
	};

	const isDisplay = () => {
		return (
			props.assignmentStatusId === AssignmentStatuses.Complete &&
			props.modifyDate &&
			!_.isNull(props.modifyDate) &&
			props.modifiedByFirstName &&
			!_.isEmpty(props.modifiedByFirstName) &&
			props.modifiedByLastName &&
			!_.isEmpty(props.modifiedByLastName)
		);
	};

	const getAssignedToRoleName = () => {
		return currentResource.roleForMember.find((r) => r.id === props.assignedToRoleId)?.role;
	};

	const getAssignedTypeDisplayName = () => {
		return currentResource.reviewerAssignments.AssignmentType.find((at) => at.id === props.assignmentTypeId)
			.displayName;
	};

	const getFormattedDate = (dueDate, dueDays) => {
		let date = moment(Date.parse(dueDate)).subtract(dueDays, 'days');
		if (date instanceof moment) {
			const dateMoment = date.format(
				userPreferences && dateFormats[userPreferences.dateFormat] && dateFormats[userPreferences.dateFormat].value
			);
			return dateMoment;
		}
		return date;
	};

	const getFormattedModifiedDate = (inputDate) => {
		let date = moment(Date.parse(inputDate));
		if (date instanceof moment) {
			const dateMoment = date.format(
				userPreferences && dateFormats[userPreferences.dateFormat] && dateFormats[userPreferences.dateFormat].value
			);
			return dateMoment;
		}
		return date;
	};

	const teamMemberText = Utility.isEmptyGuid(props.assignedToUserId)
		? getAssignedToRoleName()
		: getAssignedToUserName();

	const updateIsAssignmentComplete = () => {
		return props.assignmentStatusId === AssignmentStatuses.Open ||
			props.assignmentStatusId === AssignmentStatuses.InProcess
			? true
			: false;
	};

	const isAutomaticHandoffAllowed = () => {
		return (
			props.assignmentStatusId === AssignmentStatuses.InProcess &&
			props.assignedToUserId === userPreferences.id &&
			props.taskTypeId !== TaskTypeEnum.DEFICIENCY_RESPONSE_TASK &&
			props.taskTypeId !== TaskTypeEnum.MISSTATEMENT_RESPONSE_TASK
		);
	};

	const updateTaskAssigments = () => {
		dispatch(getTaskById(props.engagementId, props.taskId))
			.then(() => {
				dispatch(getAssignmentsByTaskId(props.engagementId, props.taskId)).catch(() => {
					setIsLoading(false);
				});
			})
			.catch(() => {
				setIsLoading(false);
			});
	};

	const onAssignmentIconClick = () => {
		let data = [
			{
				value: {
					assignmentId: props.assignmentId,
					taskTypeId: props.taskTypeId,
					taskAssignmentId: props.taskAssignmentId,
					isAssignmentComplete: updateIsAssignmentComplete(),
					isAutomaticHandoffAllowed: isAutomaticHandoffAllowed(),
					assignedToRoleId: props.assignedToRoleId || null,
					assignedToUserId: props.assignedtoUserId || null,
					currentUserId: userPreferences.id,
					currentUserFirstName: userPreferences.firstName,
					currentUserLastName: userPreferences.lastName
				},
				path: 'CompleteAssignment',
				op: 'replace'
			}
		];
		setIsLoading(true);
		dispatch(updateTaskAssignmentStatus(props.engagementId, props.taskId, data))
			.then(() => {
				updateTaskAssigments();
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	return (
		<React.Fragment>
			<StyledAssignmentText className={`assignmentTextWrapper ${isLoading ? 'isloading' : ''}`}>
				<section className="assignmentText">
					{isLoading && <section className="assignmentTextOverlay" />}
					<button
						className="assignment-status-btn"
						title={getAssignmentsTitletip()}
						id={props.taskAssignmentId}
						onClick={(e) => onAssignmentIconClick()}
					>
						<StyledCircleProportion
							title={getAssignmentsTitletip()}
							className={`circle-proportion-wrp ${isAssignmentComplete()} left`}
							size={22}
						>
							<div className="outer-circle" />
							<div className="inner-circle" />
						</StyledCircleProportion>
					</button>
				</section>
				<section className="reviewerAssignmentWrapper">
					<section className="reviewerAssignment">
						<span title={getAssignedTypeDisplayName()} className="roleName">
							{getAssignedTypeDisplayName()}
						</span>
					</section>
					<section className="assignmentNameText">
						<EllipsesControl content={props.assignmentName} tooltip={props.assignmentName} noOfLines={1} />
					</section>
					<StyledClosedBy className="closed-by-label-wrp">
						{isDisplay() && (
							<span
								className="closed-by-label"
								title={`${currentResource.reviewerAssignments.closedByAssigmentLabel} ${props.modifiedByFirstName} ${
									props.modifiedByLastName
								} ${currentResource.reviewerAssignments.onAssingmentLabel} ${getFormattedModifiedDate(
									props.modifyDate
								)}`}
							>
								{`${currentResource.reviewerAssignments.closedByAssigmentLabel} ${props.modifiedByFirstName} ${props.modifiedByLastName} ${currentResource.reviewerAssignments.onAssingmentLabel} `}
								<Moment
									format={
										userPreferences &&
										dateFormats[userPreferences.dateFormat] &&
										dateFormats[userPreferences.dateFormat].value
									}
								>
									{props.modifyDate}
								</Moment>
							</span>
						)}
					</StyledClosedBy>
				</section>
			</StyledAssignmentText>
			<section className="teamMemberText">
				<EllipsesControl content={teamMemberText} tooltip={teamMemberText} noOfLines={1} />
			</section>
			<section className="dueText">
				<section className="dueDateText">{`${props.dueDays} ${currentResource.reviewerAssignments.daysPriorToEndDate}`}</section>
				<section className="dueDateValue">{getFormattedDate(props.dueDate, props.dueDays)}</section>
			</section>
		</React.Fragment>
	);
}

export default AssignmentsItem;

const StyledAssignmentText = styled.section`
	&.isloading {
		pointer-events: none;
	}
	&:hover {
		.closed-by-label-wrp {
			opacity: 0.9;
		}
	}
	.motif-loader-container {
		position: absolute !important;
	}
	.assignmentText {
		height: var(--px-22);
		width: var(--px-22);
		display: flex;
		justify-content: center;
		.assignmentTextOverlay {
			background: var(--neutrals-300);
			opacity: 0.5;
			position: absolute !important;
			width: 100%;
			height: 100%;
			left: 0;
			top: 0;
			z-index: 10 !important;
			pointer-events: none;
		}
		.motif-tooltip-wrapper {
			width: var(--px-20);
			height: var(--px-20);
			.motif-tooltip-trigger-wrap {
				.motif-button {
					width: 100%;
					height: 100%;
				}
			}
		}
	}
`;

const StyledClosedBy = styled.section`
	&.closed-by-label-wrp {
		opacity: 0;
		transition: 0.2s ease-in-out opacity;
		min-height: var(--px-13);
		display: inline-block;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
		width: 100%;
		line-height: normal;
		.closed-by-label {
			font-size: var(--px-10);
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			color: var(--neutrals-700);
		}
	}
`;

const StyledCircleProportion = styled.div`
	min-width: var(--px-22);
	min-height: var(--px-22);
	width: var(--px-22);
	height: var(--px-22);
	position: relative;
	&.half .inner-circle {
		clip-path: polygon(0 0, 50% 0, 50% 100%, 0 100%);
	}
	&.half.right .inner-circle {
		clip-path: polygon(100% 0, 50% 0, 50% 100%, 100% 100%);
	}
	&.quarter .inner-circle {
		clip-path: polygon(0 0, 50% 0, 50% 50%, 0 50%);
	}
	&.quarter.top-right .inner-circle {
		clip-path: polygon(100% 0, 50% 0, 50% 50%, 100% 50%);
	}
	&.quarter.bottom-left .inner-circle {
		clip-path: polygon(0 50%, 50% 50%, 50% 100%, 0 100%);
	}
	&.quarter.bottom-right .inner-circle {
		clip-path: polygon(100% 100%, 50% 100%, 50% 50%, 100% 50%);
	}
	&.three-quarters .inner-circle {
		clip-path: polygon(50% 0, 50% 50%, 100% 50%, 100% 100%, 0 100%, 0 0);
	}
	&.empty .inner-circle {
		display: none;
	}
	.outer-circle {
		border: var(--px-2) solid var(--blue-500);
		border-radius: var(--px-50);
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
	.inner-circle {
		position: absolute;
		width: 100%;
		height: 100%;
		transform: scale(0.6);
		background: var(--blue-500);
		border-radius: var(--px-50);
	}
`;
